$(document).ready(function() {
  $('.video-banner-main').each(function() {
    var $section = $(this);
    var $popup = $section.find('.video-popup');
    var $modal = $section.find('.modal');
    var $frame = $section.find('.video-container iframe');
    var videoUrl = $frame.attr('data-src');

    function closeVideo() {
      $frame.attr('src', '');
      $popup.fadeOut(200);
      $modal.fadeOut(200);
      $('body').removeClass('overlay-active');
    }

    $section.find('.watch-more').on('click', function(event) {
      event.preventDefault();
      if (videoUrl) $frame.attr('src', videoUrl + '?autoplay=1&mute=1');
      $popup.fadeIn(200);
      $modal.fadeIn(200);
      $('body').addClass('overlay-active');
    });

    $section.find('.close').on('click', function(event) {
      event.preventDefault();
      closeVideo();
    });

    $modal.on('click', function(event) {
      event.preventDefault();
      closeVideo();
    });

    $(document).on('keyup.ctVideoPopup', function(event) {
      if (event.key === 'Escape' && $popup.is(':visible')) closeVideo();
    });
  });
});





